import { useState, useCallback } from 'react';

interface ConfirmDialogState {
  open: boolean;
  message: string;
  action: (() => Promise<void>) | null;
}

const INITIAL_STATE: ConfirmDialogState = {
  open: false,
  message: 'Are you sure?',
  action: null,
};

export function useConfirmDialog() {
  const [state, setState] = useState<ConfirmDialogState>(INITIAL_STATE);

  const confirm = useCallback((message: string, action: () => Promise<void>) => {
    setState({ open: true, message, action });
  }, []);

  const close = useCallback(() => setState(INITIAL_STATE), []);

  const execute = useCallback(async () => {
    if (state.action) await state.action();
    close();
  }, [state.action, close]);

  return { confirmState: state, confirm, closeConfirm: close, executeConfirm: execute };
}